import { Controller } from "@hotwired/stimulus";
import * as Luxon from "luxon";

export default class extends Controller {
  static targets = [
    "bookingFormRequirements",
    "bookingFormSlots",
    "bookingFormPackages",
    "bookingFormOffices",
    "bookingFormPersonalDetails",
    "bookingFormZipcode",
    "dayButton",
    "eligibilityDate",
    "guardianPassword",
    "loadingContainer",
    "locale",
    "nextButtonSlots",
    "officePanel",
    "officeRadio",
    "potentialSlotsContainer",
    "slotSelectionInstructorId",
    "timeButton",
    "validationMessageZipcode",
    "zoneIds"
  ];

  connect() {
    try {
      if (typeof SignaturePad !== "undefined" && SignaturePad) {
        if (this.element.querySelector("#student-signature-canvas")) {
          this.studentSignaturePad = new SignaturePad(
            this.element.querySelector("#student-signature-canvas")
          );
        }
        if (this.element.querySelector("#guardian-signature-canvas")) {
          this.guardianSignaturePad = new SignaturePad(
            this.element.querySelector("#guardian-signature-canvas")
          );
        }
      }
    } catch (error) {
      console.error("Error initializing signature pads: ", error);
    }
  }

  selectOffice(event) {
    const clickedPanel = event.currentTarget;
    const radioButton = clickedPanel.querySelector('input[type="radio"]');
    radioButton.checked = true;
    this.updateSelectedOffice();
  }

  updateSelectedOffice() {
    this.officePanelTargets.forEach((panel, index) => {
      const radio = this.officeRadioTargets[index];
      if (radio.checked) {
        panel.classList.add("Panel--highlight");
        panel.classList.remove("Panel--borderOnly");
      } else {
        panel.classList.remove("Panel--highlight");
        panel.classList.add("Panel--borderOnly");
      }
    })
  }

  submit(event) {
    event.preventDefault();

    const errorMessagesPanel = document.getElementById("error-messages-panel");
    if (errorMessagesPanel) {
      errorMessagesPanel.hidden = true;
    }

    // disable the  payment-button button
    const paymentButton = document.getElementById("payment-button");
    paymentButton.disabled = true;

    const spinnerTarget = document.getElementById("payment-button-spinner");
    if (paymentButton) {
      switch (paymentButton.id) {
        case "payment-button":
          if (spinnerTarget != undefined) {
            spinnerTarget.classList.remove("u-hidden");
            spinnerTarget.classList.add("u-inlineBlock");
          }
          break;
        default:
          break;
      }
    }

    const formData = new FormData(event.target);
    const url = event.target.action;
    const method = event.target.method;

    fetch(url, {
      method: method,
      body: formData,
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((data) => {
        if (data.url) {
          window.location.href = data.url;
        }
      })
      .catch((response) => {
        if (spinnerTarget != undefined) {
          spinnerTarget.classList.add("u-hidden");
          spinnerTarget.classList.remove("u-inlineBlock");
        }

        paymentButton.disabled = false;
        if (response.status === 400) {
          response.json().then((errorData) => {
            if (errorData.error === "slot_taken") {
              const bookingFormDriveTestPackages = document.getElementById("us-booking-drive-test-packages");
              if (bookingFormDriveTestPackages) {
                bookingFormDriveTestPackages.hidden = true;
              }

              const bookingFormDriveTestSlotPicker = document.getElementById("us-booking-drive-test-slot-picker");
              if (bookingFormDriveTestSlotPicker) {
                bookingFormDriveTestSlotPicker.hidden = false;
              }

              const errorSlotTaken =
                document.getElementById("error-slot-taken");
              if (errorSlotTaken) {
                errorSlotTaken.hidden = false;
              }

              window.scrollTo(0, 0);
            }
          });
        } else {
          const errorMessagesPanel = document.getElementById(
            "error-messages-panel"
          );
          if (errorMessagesPanel) {
            errorMessagesPanel.hidden = false;
          }
          paymentButton.disabled = false;
          console.error("Error:", response);
          const responseBodyJson = response.json();
          alert("Something has went wrong, please try again later");
        }
      });
  }

  async showLoader() {
    if (this.targets.find("potentialSlotsContainer")) {
      this.targets.find("potentialSlotsContainer").classList.add("hidden");
      this.targets.find("loadingContainer").classList.remove("hidden");
    }
  }

  async hideLoader() {
    if (this.targets.find("potentialSlotsContainer")) {
      this.targets.find("potentialSlotsContainer").classList.remove("hidden");
      this.targets.find("loadingContainer").classList.add("hidden");
    }
  }

  getDateofBirth() {
    const yearElement = document.querySelector('select[id$="_1i"]');
    const monthElement = document.querySelector('select[id$="_2i"]');
    const dayElement = document.querySelector('select[id$="_3i"]');

    if (!yearElement || !monthElement || !dayElement) {
      return null;
    }

    const day = dayElement.options[dayElement.selectedIndex].value;
    const month = monthElement.options[monthElement.selectedIndex].value;
    const year = yearElement.options[yearElement.selectedIndex].value;

    return `${year}-${month}-${day}`;
  }

  calculateAge() {
    var dateOfBirth = this.getDateofBirth();
    if (!dateOfBirth) {
      return 0;
    }

    const parts = dateOfBirth.split("-");
    const formattedDateOfBirth = parts.join("/");
    var dob = new Date(formattedDateOfBirth);
    var today = new Date();

    var age = today.getFullYear() - dob.getFullYear();
    var monthDiff = today.getMonth() - dob.getMonth();
    var dayDiff = today.getDate() - dob.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }

  relationShipToStudentChanged(event) {
    this.changeWhichFieldsAreRequired();
    const age = this.calculateAge();
    const guardianDetails = document.querySelector("#booking-guardian-details");
    const bookingForMyself = document.querySelector(
      "#driving_school_booking_enrolling_for_myself"
    );

    if (!bookingForMyself) {
      return;
    }

    if (age >= 18) {
      guardianDetails.hidden = true;
      return;
    }

    if (bookingForMyself.checked) {
      guardianDetails.hidden = false;
      return;
    }

    const selectInput = document.querySelector(
      "#driving_school_booking_relationship_to_student"
    );

    const selectedOption = selectInput.value;
    if (selectedOption === "Parent/Guardian") {
      guardianDetails.hidden = true;
    } else {
      guardianDetails.hidden = false;
    }
  }

  changeWhichFieldsAreRequired() {
    const yourEmailInput = document.querySelector("#email_value");
    const yourEmailLabel = document.querySelector("#your_email_label");
    const yourCellNumberInput = document.querySelector("#cell_number_value");
    const yourCellNumberLabel = document.querySelector("#cell_number_label");

    if (!this.isYourEmailRequired()) {
      yourEmailInput.required = false;
      yourEmailInput.classList.remove("isRequiredLocalised");
      yourEmailLabel.classList.remove("isRequiredLocalised");
      yourEmailInput.classList.add("isRecommendedLocalised");
      yourEmailLabel.classList.add("isRecommendedLocalised");
      yourCellNumberInput.required = false;
      yourCellNumberInput.classList.remove("isRequiredLocalised");
      yourCellNumberLabel.classList.remove("isRequiredLocalised");
      yourCellNumberInput.classList.add("isRecommendedLocalised");
      yourCellNumberLabel.classList.add("isRecommendedLocalised");
    } else {
      yourEmailInput.required = true;
      yourEmailInput.classList.add("isRequiredLocalised");
      yourEmailLabel.classList.add("isRequiredLocalised");
      yourEmailInput.classList.remove("isRecommendedLocalised");
      yourEmailLabel.classList.remove("isRecommendedLocalised");
      yourCellNumberInput.required = true;
      yourCellNumberInput.classList.add("isRequiredLocalised");
      yourCellNumberLabel.classList.add("isRequiredLocalised");
      yourCellNumberInput.classList.remove("isRecommendedLocalised");
      yourCellNumberLabel.classList.remove("isRecommendedLocalised");
    }

    const studentEmailInput = document.querySelector("#student_email_value");
    const studentEmailLabel = document.querySelector("#student_email_label");
    const studentCellNumberInput = document.querySelector(
      "#student_cell_number_value"
    );
    const studentCellNumberLabel = document.querySelector(
      "#student_cell_number_label"
    );
    if (!this.isStudentEmailRequired()) {
      studentEmailInput.required = false;
      studentEmailInput.classList.remove("isRequiredLocalised");
      studentEmailLabel.classList.remove("isRequiredLocalised");
      studentEmailInput.classList.add("isRecommendedLocalised");
      studentEmailLabel.classList.add("isRecommendedLocalised");
      studentCellNumberInput.required = false;
      studentCellNumberInput.classList.remove("isRequiredLocalised");
      studentCellNumberLabel.classList.remove("isRequiredLocalised");
      studentCellNumberInput.classList.add("isRecommendedLocalised");
      studentCellNumberLabel.classList.add("isRecommendedLocalised");
    } else {
      studentEmailInput.required = true;
      studentEmailInput.classList.add("isRequiredLocalised");
      studentEmailLabel.classList.add("isRequiredLocalised");
      studentEmailInput.classList.remove("isRecommendedLocalised");
      studentEmailLabel.classList.remove("isRecommendedLocalised");
      studentCellNumberInput.required = true;
      studentCellNumberInput.classList.add("isRequiredLocalised");
      studentCellNumberLabel.classList.add("isRequiredLocalised");
      studentCellNumberInput.classList.remove("isRecommendedLocalised");
      studentCellNumberLabel.classList.remove("isRecommendedLocalised");
    }
  }

  isYourEmailRequired() {
    return true;
  }

  isStudentEmailRequired() {
    const age = this.calculateAge();
    const isAdult = age >= 18;

    if (isAdult) {
      const relationship = document.querySelector(
        "#driving_school_booking_relationship_to_student"
      ).value;

      if (
        ["Family member", "Friend", "Work colleague"].includes(relationship)
      ) {
        return true;
      } else {
      }
    }

    return false;
  }

  toggleActiveTime(event) {
    event.preventDefault();

    this.timeButtonTargets.forEach((button) => {
      button.classList.remove("isActive");
    });

    event.currentTarget.classList.add("isActive");

    let slotIsoTime = event.currentTarget.getAttribute("data-slot-iso-time");
    document.getElementById("picked_slot_time").value =
      event.currentTarget.textContent.trim();
    document.getElementById("picked_slot_iso_time").value = slotIsoTime;
  }

  toggleActiveDay(event) {
    event.preventDefault();

    this.dayButtonTargets.forEach((button) => {
      button.classList.remove("isActive");
    });

    event.currentTarget.classList.add("isActive");

    document.getElementById("picked_slot_day").value =
      event.currentTarget.textContent.trim();
    document.getElementById("picked_slot_time").value = "";
  }

  formatDate(inputStr) {
    const dateStr = inputStr.split(" ")[1];

    let [month, day, year] = dateStr.split("/");

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const currentDay = currentDate.getDate();

    year =
      currentMonth > month || (currentMonth == month && currentDay > day)
        ? currentYear + 1
        : currentYear;

    return `${year}_${month}_${day}`;
  }

  async get_drive_test_slots(event, start_date = null) {
    this.showLoader();

    const formatted_date =
      start_date !== null
        ? this.formatDateToStringForSlots(new Date(start_date))
        : this.formatDate(document.getElementById("picked_slot_day").value);

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const school_token = document
      .getElementById("us-school-token")
      .innerHTML.trim();

    const isAutomaticSelected = optionalChaining(
      () =>
        document.getElementById(
          "driving_school_booking_gearbox_preference_automatic"
        ).checked || false
    );

    const test_center_zone_ids = this.hasZoneIdsTarget ? this.zoneIdsTarget.value : "";

    let instructorId = "Any";
    if (this.hasSlotSelectionInstructorIdTarget) {
      instructorId = this.slotSelectionInstructorIdTarget?.value || "Any";
    }

    const eligibility_date = this.hasEligibilityDateTarget ? this.eligibilityDateTarget.value : null;

    const locale = this.getLocale();
    const response = await fetch(
      `/us/drive-test-slots/${school_token}/${formatted_date}?is_automatic_transmission=${isAutomaticSelected}&instructor_id=${instructorId}&locale=${locale}`,
      {
        method: "POST",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          driving_school_token: school_token,
          start_date: formatted_date,
          test_center_zone_ids: test_center_zone_ids,
          eligibility_date: eligibility_date
        }),
      }
    );

    if (response.ok) {
      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");
      const targetElement = document.getElementById("potential_slots");

      if (template && targetElement) {
        targetElement.innerHTML = "";
        targetElement.appendChild(template.content.cloneNode(true));
      }
    }
    await this.hideLoader();
  }
  
  async getNextWeekStartDate(dateString) {
    let [year, month, day] = dateString.split("-");
    let nextWeekStartDate = new Date(year, month - 1, day);
    nextWeekStartDate.setDate(nextWeekStartDate.getDate() + 7);

    nextWeekStartDate.setHours(0, 0, 0, 0);
    return nextWeekStartDate;
  }

  async getTodayStartDate(dateString) {
    let [year, month, day] = dateString.split("-");
    let todayStartDate = new Date(year, month - 1, day);
    todayStartDate.setHours(0, 0, 0, 0);
    return todayStartDate;
  }

  async getPreviousWeekStartDate(dateString) {
    let previousWeekStartDate = new Date(dateString);
    previousWeekStartDate.setDate(previousWeekStartDate.getUTCDate() - 7);
    previousWeekStartDate.setHours(0, 0, 0, 0);
    return previousWeekStartDate;
  }

  async slotsNextWeek(event) {
    event.preventDefault();
    const startingDate = event.currentTarget.dataset.startingDate;
    let startDate = await this.getNextWeekStartDate(startingDate);
    startDate = this.formatDateToString(startDate);
    await this.get_next_drive_test_slot_day(startDate, "calendar_next_week", false);
  }

  async slotsToday(event) {
    event.preventDefault();
    const startingDate = event.currentTarget.dataset.startingDate;
    let startDate = await this.getTodayStartDate(startingDate);
    startDate = this.formatDateToString(startDate);
    await this.get_next_drive_test_slot_day(startDate, "calendar_next_week", false);
  }

  async slotsPreviousWeek(event) {
    event.preventDefault();
    const startingDate = event.currentTarget.dataset.startingDate;
    let startDate = await this.getPreviousWeekStartDate(startingDate);
    startDate = this.formatDateToString(startDate);
    await this.get_next_drive_test_slot_day(startDate, "calendar_previous_week", false);
  }

  async fetchAndUpdateCalendar(action, startingDate, driveTest = false) {
    let action_word = "previous_week";
    if (action.startsWith("calendar_")) {
      action_word = action.substring("calendar_".length);
    } else {
      alert(action);
    }

    const locale = this.getLocale();
    this.updateNavigationButtons(startingDate, action_word);
    let url = `/us/slots/calendar/${action_word}/${startingDate}?locale=${locale}`;

    if (driveTest) {
      url += `&drive_test=true`;
    }

    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    if (response.ok) {
      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");
      const targetElement = document.getElementById("slots-day-picker");

      if (template && targetElement) {
        targetElement.innerHTML = "";
        targetElement.appendChild(template.content.cloneNode(true));
      }
    }
  }

  async updateNavigationButtons(startingDate, action) {
    startingDate = this.parseDateString(startingDate);

    const previousWeekButton = document.querySelector(
      "[data-action='click->driving-school-drive-test-booking-form#slotsPreviousWeek']"
    );
    const todayButton = document.getElementById("slots-picker-today-button");
    const nextWeekButton = document.querySelector(
      "[data-action='click->driving-school-drive-test-booking-form#slotsNextWeek']"
    );

    const previousWeekStartingDate = new Date(startingDate);
    const nextWeekStartingDate = new Date(startingDate);

    if (action == "previous_week") {
      previousWeekStartingDate.setDate(startingDate.getDate() - 7);
      nextWeekStartingDate.setDate(startingDate.getDate() - 7);
    } else {
      previousWeekStartingDate.setDate(startingDate.getDate() + 7);
      nextWeekStartingDate.setDate(startingDate.getDate() + 7);
    }

    await this.disable_previous_week_button(previousWeekStartingDate);
    if (previousWeekButton) {
      previousWeekButton.dataset.startingDate = this.formatDateToString(
        previousWeekStartingDate
      );
    }
    if (nextWeekButton) {
      nextWeekButton.dataset.startingDate =
        this.formatDateToString(nextWeekStartingDate);
    }
    if (todayButton) {
      todayButton.dataset.startingDate =
        this.formatDateToString(nextWeekStartingDate);
    }
  }

  formatDateToString(date) {
    return this.formatStringDate(date, "-");
  }

  formatDateToStringForSlots(date) {
    return this.formatStringDate(date, "_");
  }

  formatStringDate(date, separator) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so add 1
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}${separator}${month}${separator}${day}`;
  }

  parseDateString(dateString) {
    const cleanedDateString = dateString.replace(/"/g, ""); // Remove double quotes
    const [year, month, day] = cleanedDateString.split("-").map(Number);
    return new Date(year, month - 1, day); // Subtract 1 from the month since it's 0-indexed
  }

  async nextButtonPersonalDetailsPressed(event) {
    event.preventDefault();

    const errors = await this.validatePersonalDetailsForm();

    const validationMessage = document.getElementById("validation-message-1");
    if (errors.length > 0) {
      validationMessage.innerHTML = errors.join("<br>");
      validationMessage.hidden = false;
    } else {
      validationMessage.hidden = true;
      this.updatePackages();
      let enrollmentTypeElement = document.getElementById(
        "us-school-enrollment-flow"
      );
      let enrollmentType = enrollmentTypeElement
        ? enrollmentTypeElement.innerHTML.trim()
        : "";
            if (enrollmentType == "classroom") {
        this.bookingFormPersonalDetailsTarget.hidden = true;
      } else {
        this.bookingFormPersonalDetailsTarget.hidden = true;
        this.bookingFormRequirementsTarget.hidden = false;
      }
      window.scrollTo(0, 0);
    }
  }

  nextButtonRequirementsPressed(event) {
    event.preventDefault();
    this.bookingFormRequirementsTarget.hidden = true;
    this.bookingFormPackagesTarget.hidden = false;
  }

  async nextButtonZipcodePressed(event) {
    event.preventDefault();

    const errors = this.validateZipcodeForm();

    const validationMessage = this.validationMessageZipcodeTarget;

    if (errors.length > 0) {
      validationMessage.innerHTML = errors.join("<br>");
      validationMessage.hidden = false;
      return;
    }

    validationMessage.hidden = true;

    const zipcode = document.getElementById("zipcode_value").value;
    const school_token = document
      .getElementById("us-school-token")
      .innerHTML.trim();

    const locale = this.getLocale();
    let url = `/us/${school_token}/drive-test/location-search/${zipcode}?locale=${locale}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    });

    const stream = await response.text();

    Turbo.renderStreamMessage(stream);

    this.bookingFormZipcodeTarget.hidden = true;
    this.bookingFormOfficesTarget.hidden = false;
  }

  async nextButtonOfficesPressed(event) {
    event.preventDefault();

    let button = event.currentTarget;
    let spinner = button.querySelector(".Spinner");
    spinner.classList.remove("u-hidden");
    spinner.classList.add("u-inlineBlock");
    button.disabled = true;

    let todayDate = new Date();
    todayDate.setDate(todayDate.getDate());
    todayDate = this.formatDateToString(todayDate);

    let allowStudentsToSchedule = document.getElementById(
      "driving-school-rule-allow-students-to-schedule"
    ).innerHTML;
    allowStudentsToSchedule = allowStudentsToSchedule.trim();

    const selectedOfficeField = document.querySelector(
      '#drive-test-locations-list input[name="selected_office"]:checked'
    );
    const selectedOfficeId = selectedOfficeField.value;

    const selectedOfficeZoneIds = await this.fetchSelectedOfficeZoneIds(selectedOfficeId);
    if (selectedOfficeZoneIds === null) {
      spinner.classList.add("u-hidden");
      spinner.classList.remove("u-inlineBlock");
      button.disabled = false;
      return;
    }

    if (this.hasZoneIdsTarget && Array.isArray(selectedOfficeZoneIds)) {
      this.zoneIdsTarget.value = selectedOfficeZoneIds.join(",");
    }

    if (allowStudentsToSchedule === "true") {
      this.bookingFormOfficesTarget.hidden = true;
      this.bookingFormSlotsTarget.hidden = false;
      this.get_next_drive_test_slot_day(todayDate, "calendar_next_week", true);
    } else {
      this.bookingFormOfficesTarget.hidden = true;
      this.bookingFormPersonalDetailsTarget.dataset.previousStep = "offices";
      this.bookingFormPersonalDetailsTarget.hidden = false;
    }

    window.scrollTo(0, 0);

    spinner.classList.add("u-hidden");
    spinner.classList.remove("u-inlineBlock");
    button.disabled = false;
  }

  async nextButtonSlotsPressed(event) {
    this.filterPackagesUsingTransmission();

    event.preventDefault();
    const validationMessage = document.getElementById("validation-message-5");

    const errors = this.validateSlotsForm();

    if (errors.length > 0) {
      validationMessage.innerHTML = errors.join("<br>");
      validationMessage.hidden = false;
    } else {
      validationMessage.hidden = true;

      this.bookingFormSlotsTarget.hidden = true;
      this.bookingFormPersonalDetailsTarget.dataset.previousStep = "slots";
      this.bookingFormPersonalDetailsTarget.hidden = false;
    }
  }

  checkAge() {
    this.relationShipToStudentChanged();
    const guardianSignature = document.getElementById("guardian-signature");
    if (guardianSignature == null) {
      return;
    }

    let age = this.calculateAge();

    if (age >= 18) {
      document.getElementById("guardian-signature").hidden = true;
    } else {
      document.getElementById("guardian-signature").hidden = false;
    }
  }

  async updatedPackagesOnZoneAndDateOfBirth(
    school_token,
    date_of_birth,
    zone_ids
  ) {

    const packageFields = document.querySelectorAll('[id^="package_"]');
    let selectedPackageId = null;
    packageFields.forEach((packageField) => {
      if (packageField.checked) {
        selectedPackageId = packageField.id.match(/package_(\d+)_field/)[1];
      }
    });

    const locale = this.getLocale();
    const url =
      `/schools/us/dashboard/update_drive_test_packages` +
      `?date_of_birth=${date_of_birth}` +
      `&school_token=${school_token}` +
      `&is_admin=false` +
      `&selected_package_id=${selectedPackageId}` +
      `&zone_ids=${encodeURIComponent(zone_ids)}` +
      `&locale=${locale}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    });

    if (response.ok) {
      const stream = await response.text();
      Turbo.renderStreamMessage(stream);
    }
  }

  async fetchSelectedOfficeZoneIds(selectedOfficeId) {
    const schoolToken = document
      .getElementById("us-school-token")
      .innerHTML.trim();
    const url = `/us/${schoolToken}/drive-test/fetch-office-zone-ids/${selectedOfficeId}`;

    let response;
    try {
      response = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
    } catch (error) {
      console.error("Network error fetching selected office zone IDs:", error);
      return null;
    }

    if (!response.ok) {
      console.error("Failed to fetch selected office zone IDs, status:", response.status);
      return null;
    }

    let data;
    try {
      data = await response.json();
    } catch (error) {
      console.error("Failed to parse JSON for selected office zone IDs:", error);
      return null;
    }

    if (Array.isArray(data.office_zone_ids)) {
      return data.office_zone_ids;
    }

    console.error("Unexpected payload for office_zone_ids:", data.office_zone_ids);
    return null;
  }

  async get_next_drive_test_slot_day(start_date, action, selectDay) {
    this.showLoader();
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const school_token = document
      .getElementById("us-school-token")
      .innerHTML.trim();
    const isAutomaticSelected = optionalChaining(
      () =>
        document.getElementById(
          "driving_school_booking_gearbox_preference_automatic"
        ).checked || false
    );

    const eligibility_date = this.hasEligibilityDateTarget ? this.eligibilityDateTarget.value : null;

    // check start_date and make sure it is in the correct format YYYY-MM-DD and it isn't null and it isn't NaN-NaN-NaN
    if (
      start_date == null ||
      start_date == undefined ||
      start_date == "NaN-NaN-NaN" ||
      start_date == "Invalid Date"
    ) {
      alert(
        "The date picked is not valid. Please try again, or contact us if the problem persists."
      );
      return;
    }

    let instructorId = "Any";
    if (this.hasSlotSelectionInstructorIdTarget) {
      instructorId = this.slotSelectionInstructorIdTarget.value;
    }

    const selected_office_zone_ids = this.hasZoneIdsTarget ? this.zoneIdsTarget.value : "";

    const response = await fetch(
      `/us/select-next-drive-test-slot-day/${school_token}` +
        `?start_time=${start_date}` +
        `&week_action=${action}` +
        `&week_change=${selectDay}` +
        `&is_automatic=${isAutomaticSelected}` +
        `&instructor_id=${instructorId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          driving_school_token: school_token,
          selected_office_zone_ids: selected_office_zone_ids,
          is_initial_load: selectDay,
          eligibility_date: eligibility_date
        })
      }
    );

    if (response.ok) {
      const data = await response.json();

      const start_date = data.selected_date;
      const selected_day = data.selected_day;
      const week_start_date = data.week_start_date;
      const disabled_days = data.disabled_days;
      const no_slots_available = data.no_slots_available;
      const time_zone = data.time_zone;

      let date_with_time_zone = start_date
        ? Luxon.DateTime.fromISO(start_date, { zone: time_zone }).startOf("day")
        : Luxon.DateTime.now({ zone: time_zone }).startOf("day");

      if (week_start_date !== null) {
        await this.fetchAndUpdateCalendar(action, week_start_date, true);
      }
      this.disable_week_days(disabled_days);
      if (start_date !== null && selected_day !== null) {
        this.get_drive_test_slots(null, date_with_time_zone);
        this.select_slot_day(selected_day);
      }
      this.displayNoSlotAvailable(!no_slots_available);
    } else {
      console.error("Request failed:", response.status);
    }
  }

  displayNoSlotAvailable(future_potentials_slots) {
    const noSlot = document.getElementById("no_slot_available");
    const weekView = document.getElementById("week-view-slots");
    if (future_potentials_slots) {
      if (noSlot) noSlot.hidden = true;
      if (weekView) weekView.hidden = false;
    } else {
      if (noSlot) noSlot.hidden = false;
      if (weekView) weekView.hidden = true;

      const nextButton = this.nextButtonSlotsTarget;
      if (nextButton) nextButton.disabled = true;
    }
  }

  async disable_previous_week_button(week_start_date) {
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    const weekStartDate = new Date(week_start_date);
    const selectedDayButton = document.getElementById(
      "slots-picker-previous-week-button"
    );

    if (weekStartDate <= todayDate && selectedDayButton) {
      selectedDayButton.classList.add("Button--disabled");
    } else {
      if (selectedDayButton) {
        selectedDayButton.classList.remove("Button--disabled");
      }
    }
  }

  async select_slot_day(selected_day) {
    this.dayButtonTargets.forEach((button) => {
      button.classList.remove("isActive");
    });

    const selectedDayButton = document.getElementById(`day-${selected_day}`);
    selectedDayButton.classList.add("isActive");

    // Set the value of the hidden field with the label of the button that was pressed
    document.getElementById("picked_slot_day").value =
      selectedDayButton.textContent.trim();
    document.getElementById("picked_slot_time").value = "";
  }

  async disable_week_days(disabled_days) {
    disabled_days.forEach((day) => {
      const dayButton = document.getElementById(`day-${day}`);
      if (dayButton) {
        dayButton.classList.add("Button--disabled");
      }
    });
  }

  filter_on_transmission_change() {
    let todayDate = new Date();
    todayDate.setDate(todayDate.getDate());
    todayDate = this.formatDateToString(todayDate);

    this.get_next_drive_test_slot_day(todayDate, "calendar_next_week", true);
  }

  async updatePackages() {
    const school_token = document
      .getElementById("us-school-token")
      .innerHTML.trim();
    const dateOfBirth = this.getDateofBirth();

    this.updatedPackagesOnZoneAndDateOfBirth(
      school_token,
      dateOfBirth,
      this.zoneIdsTarget.value
    );
  }

  backButtonOfficesPressed(event) {
    this.bookingFormOfficesTarget.hidden = true;
    this.bookingFormZipcodeTarget.hidden = false;
  }

  backButtonSlotsPressed(event) {
    this.bookingFormSlotsTarget.hidden = true;
    this.bookingFormOfficesTarget.hidden = false;
  }

  backButtonPersonalDetailsPressed(event) {
    event.preventDefault();
    const previousStep = this.bookingFormPersonalDetailsTarget.dataset.previousStep;
    this.bookingFormPersonalDetailsTarget.hidden = true;
    
    if (previousStep === "slots") {
      this.bookingFormSlotsTarget.hidden = false;
    } else if (previousStep === "offices") {
      this.bookingFormOfficesTarget.hidden = false;
    } else {
      // Fallback: go back to the first step
      if (this.hasBookingFormZipcodeTarget) {
        this.bookingFormZipcodeTarget.hidden = false;
      }
    }
  }

  backButtonRequirementsPressed(event) {
    event.preventDefault();
    this.bookingFormPersonalDetailsTarget.hidden = false;
    this.bookingFormRequirementsTarget.hidden = true;
  }

  backButtonPackagesPressed(event) {
    event.preventDefault();
    this.bookingFormRequirementsTarget.hidden = false;
    this.bookingFormPackagesTarget.hidden = true;
  }

  isValidDate(dateString) {
    const parts = dateString.split("-"); // Assuming the format is YYYY-MM-DD
    if (parts.length !== 3) {
      return false; // Not a valid format
    }

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed in JavaScript Date
    const day = parseInt(parts[2], 10);

    const date = new Date(year, month, day);

    // Check if the date has rolled over to the next month or year, which means the day was invalid
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month ||
      date.getDate() !== day
    ) {
      return false; // The date rolled over, so it's invalid
    }

    return true;
  }

  getSelectedDate(prefix) {
    var year = document.getElementById(prefix + "_1i").value;
    var month = document.getElementById(prefix + "_2i").value;
    var day = document.getElementById(prefix + "_3i").value;
    return year + "-" + month + "-" + day; // returns a string in "YYYY-MM-DD" format
  }

  getDateFromSelectedDate(prefix) {
    var year = parseInt(document.getElementById(prefix + "_1i").value, 10);
    var month = parseInt(document.getElementById(prefix + "_2i").value, 10) - 1; // months are 0-indexed in JavaScript Date
    var day = parseInt(document.getElementById(prefix + "_3i").value, 10);
    return new Date(year, month, day);
  }

  async validatePersonalDetailsForm() {
    let validationErrors = [];

    const bookingFormPersonalDetails = this.bookingFormPersonalDetailsTarget;

    const isStudentEmailRequired = this.isStudentEmailRequired();
    const isYourEmailRequired = this.isYourEmailRequired();

    const yourEmailField = document.getElementById("email_value");
    const yourCellField = document.getElementById("cell_number_value");

    if (yourEmailField && yourCellField) {
      const emailValue = yourEmailField.value || "";
      const emailIsEmpty = emailValue.trim() === "";
      const emailIsValid =
        /^\w+([\.-]?\w+|\+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailValue);
      const cellValue = yourCellField.value || "";
      const cellIsEmpty = cellValue.trim() === "";
      const cellIsValid = this.isValidPhoneNumber(cellValue);

      if (isYourEmailRequired && cellIsEmpty) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "cell_number_invalid",
          "Please enter a valid cell number."
        );
        validationErrors.push(errorMessage);
      }

      if (!cellIsEmpty && !cellIsValid) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "cell_number_invalid",
          "Please enter a valid cell number by removing any brackets, hyphens, fullstops or spaces."
        );
        validationErrors.push(errorMessage);
      }

      if (isYourEmailRequired && emailIsEmpty) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "required.email",
          "Email address cannot be empty."
        );
        validationErrors.push(errorMessage);
      }

      if (!emailIsEmpty && !emailIsValid) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "email_invalid",
          "Please enter a valid email address."
        );
        validationErrors.push(errorMessage);
      }

      if (!emailIsEmpty && emailIsValid) {
        const emailTaken = await this.isEmailAlreadyTaken(emailValue);
        const guardianEmailTaken =
          await this.isGuardianSigningUpSelfAndHasEmailTaken(emailValue);

        if (
          guardianEmailTaken &&
          guardianEmailTaken.email_taken &&
          guardianEmailTaken.is_guardian
        ) {
          const guardianPassword = `${this.guardianPasswordTarget.value}` || "";
          const guardianPasswordCorrect = await this.isGuardianPasswordCorrect(
            emailValue,
            guardianPassword
          );
          if (!guardianPasswordCorrect) {
            const errorMessage = this.getValidationError(
              bookingFormPersonalDetails,
              "guardian_email_invalid_password",
              "The password for this parent/guardian email is invalid. Please check your email and password then try again."
            );
            validationErrors.push(errorMessage);
          }
        } else if (emailTaken) {
          const errorMessage = this.getValidationError(
            bookingFormPersonalDetails,
            "email_taken",
            "This email is already taken."
          );
          validationErrors.push(errorMessage);
        }
      }
    }

    const requiredFields = [
      {
        id: "first_name_value",
        name: "First name",
        key: "required.first_name",
      },
      { id: "last_name_value", name: "Last name", key: "required.last_name" },
      { id: "driving_school_booking_gender_female", name: "Gender" },
      { id: "how_did_you_hear_about_us", name: "How did you hear about us" },
      {
        id: "permit_number_value",
        name: "Permit number",
        key: "required.permit",
      },
    ];

    const guardianDetailsShown =
      document.querySelector("#booking-guardian-details").hidden === false;

    const bookingForOther = document.getElementById(
      "driving_school_booking_enrolling_for_someone_else"
    );
    const studentEmail = document.getElementById("student_email_value");
    const studentPhone = document.getElementById("student_cell_number_value");
    const yourFirstName = document.getElementById("your_first_name_value");
    const yourLastName = document.getElementById("your_last_name_value");
    const guardianEmail = document.getElementById("guardian_email_value");

    if (bookingForOther.checked) {
      if (studentEmail.value.trim() === "" && isStudentEmailRequired) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "required.student_email",
          "Student email cannot be empty."
        );
        validationErrors.push(errorMessage);
      }
      if (studentPhone.value.trim() === "" && isStudentEmailRequired) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "required.student_phone",
          "Student cell number cannot be empty."
        );
        validationErrors.push(errorMessage);
      }
      if (yourFirstName.value.trim() === "") {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "required.your_first_name",
          "Your first name cannot be empty."
        );
        validationErrors.push(errorMessage);
      }
      if (yourLastName.value.trim() === "") {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "required.your_last_name",
          "Your last name cannot be empty."
        );
        validationErrors.push(errorMessage);
      }
    } else {
      if (studentEmail.value.trim() === "" && isStudentEmailRequired) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "required.student_email",
          "Student email cannot be empty."
        );
        validationErrors.push(errorMessage);
      }
    }

    // check student-signature is not empty
    if (this.studentSignaturePad) {
      let studentSignature = this.element.querySelector("#student-signature");
      if (
        this.studentSignaturePad.isEmpty() &&
        studentSignature.classList.contains("u-hidden") == false
      ) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "signature_empty",
          "Please ensure the student signature is not empty."
        );
        validationErrors.push(errorMessage);
      }
    }

    // check student_email_value and if it is not null or empty, then check if it is a valid email address
    if (studentEmail) {
      if (studentEmail.value.trim() !== "") {
        if (
          !/^\w+([\.-]?\w+|\+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
            studentEmail.value
          )
        ) {
          const errorMessage = this.getValidationError(
            bookingFormPersonalDetails,
            "student_email_invalid",
            "Please enter a valid email address for student."
          );
          validationErrors.push(errorMessage);
        } else if (isStudentEmailRequired) {
          const encodedEmail = btoa(studentEmail.value);
          try {
            const response = await fetch(`/us/student/${encodedEmail}/taken`);
            const data = await response.json();
            if (data.email_taken === true) {
              const errorMessage = this.getValidationError(
                bookingFormPersonalDetails,
                "student_email_taken",
                "This student email is already taken."
              );
              validationErrors.push(errorMessage);
            }
          } catch (error) {
            console.error("Error:", error);
          }
          // Check student email is not same as other email
          if (
            studentEmail.value ===
              document.getElementById("email_value").value &&
            isStudentEmailRequired
          ) {
            const errorMessage = this.getValidationError(
              bookingFormPersonalDetails,
              "student_email_same",
              "Student email cannot be the same as your email."
            );
            validationErrors.push(errorMessage);
          }
        }
      }
    }

    if (guardianDetailsShown && guardianEmail) {
      if (guardianEmail.value.trim() !== "") {
        if (
          !/^\w+([\.-]?\w+|\+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
            guardianEmail.value
          )
        ) {
          const errorMessage = this.getValidationError(
            bookingFormPersonalDetails,
            "guardian_email_invalid",
            "Please enter a valid email address for guardian."
          );
          validationErrors.push(errorMessage);
        } else {
          const encodedEmail = btoa(guardianEmail.value);
          try {
            const response = await fetch(`/us/student/${encodedEmail}/taken`);
            const data = await response.json();
            if (data.email_taken === true) {
              const errorMessage = this.getValidationError(
                bookingFormPersonalDetails,
                "guardian_email_taken",
                "This parent/guardian email is already taken."
              );
              validationErrors.push(errorMessage);
              // validationErrors.push(
              //   "This parent/guardian email is already taken."
              // );
            }
          } catch (error) {
            console.error("Error:", error);
          }

          // Check guardian email is not same as other email
          if (
            guardianEmail.value === document.getElementById("email_value").value
          ) {
            const errorMessage = this.getValidationError(
              bookingFormPersonalDetails,
              "student_guardian_email_same",
              "Student and parent/guardian email cannot be the same"
            );
            validationErrors.push(errorMessage);
          }
        }
      }
    }

    for (let field_data of requiredFields) {
      let field = document.getElementById(field_data.id);

      if (field) {
        if (field.value.trim() === "") {
          const errorMessage = this.getValidationError(
            bookingFormPersonalDetails,
            field_data.key,
            `${field_data.name} cannot be empty.`
          );
          validationErrors.push(errorMessage);
        }

        if (
          [
            "driving_school_booking_gender_female",
            "driving_school_booking_gender_male",
            "driving_school_booking_gender_non-binary",
          ].includes(field_data.id)
        ) {
          const gender_female = document.getElementById(
            "driving_school_booking_gender_female"
          );
          const gender_male = document.getElementById(
            "driving_school_booking_gender_male"
          );
          const gender_non_binary = document.getElementById(
            "driving_school_booking_gender_non-binary"
          );

          const genderErrorMessage = this.getValidationError(
            bookingFormPersonalDetails,
            "gender_select",
            "Please select your gender."
          );

          if (gender_non_binary) {
            if (
              !gender_female.checked &&
              !gender_male.checked &&
              !gender_non_binary.checked
            ) {
              validationErrors.push(genderErrorMessage);
            }
          } else {
            if (!gender_female.checked && !gender_male.checked) {
              validationErrors.push(genderErrorMessage);
            }
          }
        }
      }
    }

    // if permit_number_value is visible on the page
    const permitNumber = document.getElementById("permit_number_value");
    if (permitNumber) {
      const issueDateString = this.getSelectedDate(
        "driving_school_booking_permit_issue_date"
      );
      const expiryDateString = this.getSelectedDate(
        "driving_school_booking_permit_expiration"
      );

      if (!this.isValidDate(issueDateString)) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "permit_issue_date_invalid",
          "Please enter a valid permit issue date."
        );
        validationErrors.push(errorMessage);
      }

      if (!this.isValidDate(expiryDateString)) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "permit_expiry_date_invalid",
          "Please enter a valid permit expiry date."
        );
        validationErrors.push(errorMessage);
      }

      // this returns a DATE object. If you need a string use getSelectedDate
      let issueDate = this.getDateFromSelectedDate(
        "driving_school_booking_permit_issue_date"
      );
      let expiryDate = this.getDateFromSelectedDate(
        "driving_school_booking_permit_expiration"
      ); // Adjust the prefix based on your expiry date fields' IDs

      if (issueDate > expiryDate) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "permit_expiry_before_issue",
          "The permit expiry date cannot be before the issue date."
        );
        validationErrors.push(errorMessage);
      }

      if (issueDateString === expiryDateString) {
        const errorMessage = this.getValidationError(
          bookingFormPersonalDetails,
          "permit_expiry_same_as_issue",
          "The permit expiry date cannot be the same as the issue date."
        );
        validationErrors.push(errorMessage);
      }
    }

    let dateOfBirth = this.getSelectedDate(
      "driving_school_booking_date_of_birth"
    );

    if (!this.isValidDate(dateOfBirth)) {
      const errorMessage = this.getValidationError(
        bookingFormPersonalDetails,
        "date_of_birth_invalid",
        "Please enter a valid date of birth."
      );
      validationErrors.push(errorMessage);
    }

    return validationErrors;
  }

  isValidPhoneNumber(phoneNumberString) {
    const regex = /^\+?(\d{1,3}-?){0,2}\d{1,3}-?\d{1,4}$/;
    const hyphenCount = (phoneNumberString.match(/-/g) || []).length;
    const digitCount = phoneNumberString.replace(/\D/g, "").length;
    return (
      regex.test(phoneNumberString) &&
      hyphenCount <= 2 &&
      digitCount >= 10 &&
      digitCount <= 13
    );
  }

  async isGuardianSigningUpSelfAndHasEmailTaken(email) {
    const isSelfSignUp = document.getElementById(
      "driving_school_booking_enrolling_for_myself"
    ).checked;
    if (isSelfSignUp) return false;
    const isEmailAlreadyTaken = await this.isGuardianEmailAlreadyTaken(email);
    return isEmailAlreadyTaken;
  }

  async isGuardianPasswordCorrect(email, password) {
    const encodedEmail = btoa(email);
    try {
      const response = await fetch(
        `/us/student/${encodedEmail}/guardian_login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password: password,
          }),
        }
      );
      const data = await response.json();
      return !!data.success;
    } catch (error) {
      return false;
    }
  }

  async isGuardianEmailAlreadyTaken(email) {
    const encodedEmail = btoa(email);
    try {
      const response = await fetch(
        `/us/student/${encodedEmail}/guardian_taken`
      );
      const data = await response.json();
      return {
        email_taken: data.email_taken,
        is_guardian: data.is_guardian,
      };
    } catch (error) {
      console.error("Error:", error);
      return {
        email_taken: undefined,
        is_guardian: undefined,
      };
    }
  }

  async isEmailAlreadyTaken(email) {
    if (!email) return undefined;
    const encodedEmail = btoa(email);
    try {
      const response = await fetch(`/us/student/${encodedEmail}/taken`);
      const data = await response.json();
      return !!data.email_taken;
    } catch (error) {
      console.error("Error:", error);
      return undefined;
    }
  }

  validateZipcodeForm() {
    let validationErrors = [];

    const validPermitRequired = this.bookingFormZipcodeTarget.dataset.validPermitRequired === "true";

    const requiredFields = [
      { id: "zipcode_value", name: "Zipcode", key: "required.zipcode" },
      ...(validPermitRequired ? [{ id: "permit_number_value", name: "Permit number", key: "required.permit" }] : [])
    ];

    const bookingFormZipcode = this.bookingFormZipcodeTarget;

    requiredFields.forEach((field_data) => {
      let field = document.getElementById(field_data.id);
      if (!field) return;

      const value = field.value.trim();

      if (value.trim() === "") {
        const errorMessage = this.getValidationError(
          bookingFormZipcode,
          field_data.key,
          `${field_data.name} cannot be empty.`
        );
        validationErrors.push(errorMessage);
      }

      if (field_data.id === "zipcode_value" && value.trim().length != 5) {
        const errorMessage = this.getValidationError(
          bookingFormZipcode,
          "zipcode_length",
          `${field_data.name} must be 5 numbers.`
        );
        validationErrors.push(errorMessage);
      }

      if (validPermitRequired && field_data.id === "permit_number_value" && value !== "") {
        const school_token = document.getElementById("us-school-token").innerHTML.trim();
        const state = TOKEN_TO_STATE[school_token];
        let isValid = true;

        if (state) {
          const isPermitValid = isPermitValidForState(state, value);

          if (isPermitValid === null) {
            isValid = true;
          } else {
            isValid = isPermitValid;
          }
        } else {
          const defaultFormat = /^(?:[A-Za-z]\d{9}|\d{9}|[A-Za-z]\d{12}|[A-Za-z]\d{7})$/;
          isValid = defaultFormat.test(value);
        }

        if (!isValid) {
          const errorMessage = this.getValidationError(
            bookingFormZipcode,
            "permit_format",
            `${field_data.name} is in the incorrect format.`
          );
          validationErrors.push(errorMessage);
        }
      }
    });

    const year = document.getElementById("driving_school_booking_date_of_birth_1i").value;
    const month = document.getElementById("driving_school_booking_date_of_birth_2i").value - 1;
    const day = document.getElementById("driving_school_booking_date_of_birth_3i").value;
    const dob = new Date(year, month, day);

    const minAgeYears = Number(bookingFormZipcode.dataset.minAgeYears);
    const minAgeMonths = Number(bookingFormZipcode.dataset.minAgeMonths);
    const availabilityWindowDays = Number(bookingFormZipcode.dataset.availabilityWindowDays);

    const eligibleDate = new Date(
      dob.getFullYear() + minAgeYears,
      dob.getMonth() + minAgeMonths,
      dob.getDate()
    );

    const now = new Date();
    const windowEnd = new Date(now);
    windowEnd.setDate(now.getDate() + availabilityWindowDays);

    const permitIssueYear = document.getElementById("driving_school_booking_permit_issue_date_1i");
    const permitIssueMonth = document.getElementById("driving_school_booking_permit_issue_date_2i");
    const permitIssueDay = document.getElementById("driving_school_booking_permit_issue_date_3i");

    const permitExpiryYear = document.getElementById("driving_school_booking_permit_expiration_1i");
    const permitExpiryMonth = document.getElementById("driving_school_booking_permit_expiration_2i");
    const permitExpiryDay = document.getElementById("driving_school_booking_permit_expiration_3i");

    let permitEligibleDate = null;
    let useUnderageRule = false;
    let requiredValue = 0;
    let heldText = "";

    if (
      permitIssueYear &&
      permitIssueMonth &&
      permitIssueDay &&
      permitExpiryYear &&
      permitExpiryMonth &&
      permitExpiryDay
    ) {
      const issueYear = permitIssueYear.value,
        issueMonth = permitIssueMonth.value,
        issueDay = permitIssueDay.value;
      const expiryYear = permitExpiryYear.value,
        expiryMonth = permitExpiryMonth.value,
        expiryDay = permitExpiryDay.value;
      
      if (issueYear && issueMonth && issueDay && expiryYear && expiryMonth && expiryDay) {
        const permitIssueDate = new Date(Number(issueYear), Number(issueMonth) - 1, Number(issueDay));
        const permitExpiryDate = new Date(Number(expiryYear), Number(expiryMonth) - 1, Number(expiryDay));

        if (!isNaN(permitIssueDate.getTime()) && !isNaN(permitExpiryDate.getTime())) {
          if (permitIssueDate > now) {
            const errorMessage = this.getValidationError(
              bookingFormZipcode,
              "permit_issue_future",
              "Your permit issue date cannot be in the future."
            );

            validationErrors.push(errorMessage);
          }

          if (permitExpiryDate < now) {
            const errorMessage = this.getValidationError(
              bookingFormZipcode,
              "permit_expiry_past",
              "Your permit has expired."
            );

            validationErrors.push(errorMessage);
          }

          if (validationErrors.length === 0) {
            const permitHeldMonthsUnderage = Number(bookingFormZipcode.dataset.permitHeldMonthsUnderage);
            const permitHeldDaysOverage = Number(bookingFormZipcode.dataset.permitHeldDaysOverage);
            const eighteenthBirthday = new Date(dob.getFullYear() + 18, dob.getMonth(), dob.getDate());
            const now = new Date();

            const isUnderage = now < eighteenthBirthday;
            const isOverage = !isUnderage;

            if ((isUnderage && permitHeldMonthsUnderage > 0) || (isOverage && permitHeldDaysOverage > 0)) {
              const studentUnderageDate = new Date(
                permitIssueDate.getFullYear(),
                permitIssueDate.getMonth() + permitHeldMonthsUnderage,
                permitIssueDate.getDate()
              );

              const heldDaysEligibleDate = new Date(
                permitIssueDate.getTime() + permitHeldDaysOverage * 24 * 60 * 60 * 1000
              );
              const studentOverageDate = heldDaysEligibleDate < eighteenthBirthday ? eighteenthBirthday : heldDaysEligibleDate;

              useUnderageRule = (isUnderage && permitHeldMonthsUnderage > 0);

              if (useUnderageRule) {
                permitEligibleDate = studentUnderageDate;
                requiredValue = permitHeldMonthsUnderage;
                heldText = `${permitHeldMonthsUnderage} month(s)`;
              } else {
                permitEligibleDate = studentOverageDate;
                requiredValue = permitHeldDaysOverage;
                heldText = `${permitHeldDaysOverage} day(s)`;
              }
            }
          }
        }
      }
    }
    
    const eligibleDates = [];
    if (eligibleDate instanceof Date && !isNaN(eligibleDate.getTime())) {
      eligibleDates.push(eligibleDate);
    }
    if (permitEligibleDate instanceof Date && !isNaN(permitEligibleDate.getTime())) {
      eligibleDates.push(permitEligibleDate);
    }

    let finalEligibilityDate;
    if (eligibleDates.length === 0) {
      finalEligibilityDate = new Date();
    } else {
      finalEligibilityDate = eligibleDates.sort((a, b) => b - a)[0];
    }

    const eligibilityDateField = this.hasEligibilityDateTarget ? this.eligibilityDateTarget : document.getElementById("eligibility-date-field");
    if (eligibilityDateField) {
      const eligibleYear = finalEligibilityDate.getFullYear();
      const eligibleMonth = String(finalEligibilityDate.getMonth() + 1).padStart(2, "0");
      const eligibleDay = String(finalEligibilityDate.getDate()).padStart(2, "0");
      eligibilityDateField.value = `${eligibleYear}-${eligibleMonth}-${eligibleDay}`;
    }

    if (eligibleDate > windowEnd) {
      const ageText =
        minAgeMonths === 0
          ? `${minAgeYears} years`
          : `${minAgeYears} years and ${minAgeMonths} months`;

      validationErrors.push(
        this.getValidationError(
          bookingFormZipcode,
          "minimum_age",
          `You must be at least ${ageText} old to schedule a drive test. ` +
            `You become eligible on ${eligibleDate.toLocaleDateString()}, ` +
            `but scheduling closes on ${windowEnd.toLocaleDateString()}.`,
          {
            age: ageText,
            eligible_date: eligibleDate.toLocaleDateString(),
            window_end: windowEnd.toLocaleDateString(),
          }
        )
      );
    }

    if (requiredValue > 0 && permitEligibleDate instanceof Date && !isNaN(permitEligibleDate.getTime()) && permitEligibleDate > windowEnd) {
      const fallbackMessage =
        `You must have held your permit for at least ${heldText} before taking a drive test. ` +
        `You become eligible on ${permitEligibleDate.toLocaleDateString()}, ` +
        `but scheduling closes on ${windowEnd.toLocaleDateString()}.`;

      const permitErrorKey = useUnderageRule ? "permit_held_underage" : "permit_held_overage";

      const errorMessage = this.getValidationError(
        bookingFormZipcode,
        permitErrorKey,
        fallbackMessage,
        {
          permit_held_minimum: requiredValue,
          eligible_date: permitEligibleDate.toLocaleDateString(),
          window_end: windowEnd.toLocaleDateString(),
        }
      );

      validationErrors.push(errorMessage);
    }

    return validationErrors;
  }

  validateSlotsForm() {
    let validationErrors = [];

    const requiredFields = [{ id: "picked_slot_time", name: "Drive test slot" }];

    requiredFields.forEach((field_data) => {
      let field = document.getElementById(field_data.id);

      if (field) {
        if (field.value.trim() === "") {
          const nextButtonSlots = this.nextButtonSlotsTarget;
          const slotError =
            nextButtonSlots?.dataset?.slotError ||
            "You must pick a drive test slot";
          validationErrors.push(slotError);
        }
      }
    });

    return validationErrors;
  }

  filterPackagesUsingTransmission() {
    const isAutomaticSelected = optionalChaining(
      () =>
        document.getElementById(
          "driving_school_booking_gearbox_preference_automatic"
        ).checked || false
    );
    const isManualSelected = optionalChaining(
      () =>
        document.getElementById(
          "driving_school_booking_gearbox_preference_manual"
        ).checked || false
    );

    document
      .querySelectorAll("[data-driving-school-booking-form-is-automatic]")
      .forEach((item) => {
        item.hidden = true;
      });

    document
      .querySelectorAll("[data-driving-school-booking-form-is-manual]")
      .forEach((item) => {
        item.hidden = true;
      });

    if (isAutomaticSelected) {
      document
        .querySelectorAll(
          "[data-driving-school-booking-form-is-automatic='yes']"
        )
        .forEach((item) => {
          item.hidden = false;
        });
    }

    if (isManualSelected) {
      document
        .querySelectorAll("[data-driving-school-booking-form-is-manual='yes']")
        .forEach((item) => {
          item.hidden = false;
        });
    }
  }

  getLocale() {
    if (this.hasLocaleTarget) {
      return this.localeTarget.value;
    }

    const localeElement = document.getElementById("us-school-locale");
    if (localeElement && localeElement.value) {
      return localeElement.value;
    }

    return "en";
  }

  getValidationError(form, key, fallbackMessage, params = {}) {
    const localizedErrors = JSON.parse(
      form?.dataset?.drivingSchoolDriveTestBookingFormErrors || "{}"
    );

    let errorMessage;
    if (key.includes(".")) {
      const [parentKey, subKey] = key.split(".");
      errorMessage = localizedErrors?.[parentKey]?.[subKey] || fallbackMessage;
    } else {
      errorMessage = localizedErrors?.[key] || fallbackMessage;
    }

    Object.entries(params).forEach(([paramName, paramValue]) => {
      const regex = new RegExp(`%\\{${paramName}\\}`, "g");
      errorMessage = errorMessage.replace(regex, paramValue);
    });

    return errorMessage;
  }
}

function getMetaValue(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element.getAttribute("content");
}

function optionalChaining(valueFn) {
  try {
    return valueFn();
  } catch (e) {
    return undefined;
  }
}

const TOKEN_TO_STATE = Object.freeze({
  "primo": "CA",
  "10-and-2": "FL",
  "cantors-nv": "NV",
  "decisive-tulsa": "OK",
  "bensons-nc": "NC",
  "odec": "OR"
});

const PERMIT_PATTERNS = Object.freeze({
  // CA: 1 letter + 7 digits
  CA: [/^[A-Za-z]\d{7}$/],
  
  // FL: 1 letter + 12 digits
  FL: [/^[A-Za-z]\d{12}$/],

  // NV:
  // 9–10 digits
  // 12 digits
  NV: [/^\d{9}$/, /^\d{10}$/, /^\d{12}$/],

  // NC: 1–12 digits
  NC: [/^\d{1,12}$/],

  // OK:
  // 1 letter + 9 digits
  // 9 digits
  OK: [/^[A-Za-z]\d{9}$/, /^\d{9}$/],

  // OR:
  // 1 letter + 6 digits (Total 7)
  // 7 digits
  OR: [/^([A-Za-z]\d{6}|\d{7})$/],
});

function isPermitValidForState(state, value) {
  const patterns = PERMIT_PATTERNS[state];
  if (!patterns || !Array.isArray(patterns)) return null;
  return patterns.some((re) => re.test(value));
}

